<template>
	<div class="header-submenu">
		<div class="header-submenu__features">
			<p class="header-submenu__title">actiTIME Features</p>
			<div class="header-submenu__items">
				<a :href="featuresItem.url" :class="`header-submenu__item--${featuresItem.slug}`" v-for="featuresItem in featuresItems">
					<div class="header-submenu__item" @click="$emit('close-menu')">
						<img :src="featuresItem.icon" />
						<div class="header-submenu__link">{{ featuresItem.name }}</div>
					</div>
				</a>
			</div>
			<div class="header-submenu__item-icon header-submenu__item-icon--right">
				<link-arrow text="See all features" href="/all-actitime-features" />
			</div>
		</div>
		<ATInAction></ATInAction>
	</div>
</template>

<script>
import ATInAction from '../header/ATInAction.vue';
import LinkArrow from '../partials/LinkArrow.vue';
export default {
	data() {
		return {
			featuresItems: [
				{
					slug: 'time-tracking',
					icon: '/dist/img/header/features/time-tracking.svg',
					name: 'Time Tracking',
					url: '/simple-time-tracking',
				},
				{
					slug: 'reports-data-analysis',
					icon: '/dist/img/header/features/reports-data-analysis.svg',
					name: 'Reports & Data Analysis',
					url: '/powerful-time-reports',
				},
				{
					slug: 'project-tracking',
					icon: '/dist/img/header/features/project-tracking.svg',
					name: 'Project Tracking',
					url: '/project-and-task-management',
				},
				{
					slug: 'customer-care',
					icon: '/dist/img/header/features/customer-care.svg',
					name: 'Customer Care',
					url: '/customer-care',
				},
				{
					slug: 'billing-invoicing',
					icon: '/dist/img/header/features/billing-invoicing.svg',
					name: 'Billing & Invoicing',
					url: '/project-cost-and-client-billing',
				},
				{
					slug: 'team-management',
					icon: '/dist/img/header/features/team-management.svg',
					name: 'Team Management',
					url: '/efficient-team-management',
				},
				{
					slug: 'workflow',
					icon: '/dist/img/header/features/workflow.svg',
					name: 'Workflow',
					url: '/flexible-product-configuration',
				},
				{
					slug: 'integrations',
					icon: '/dist/img/header/features/integrations.svg',
					name: 'Integrations',
					url: '/integrations',
				},
				{
					slug: 'time-tracking-software.pdf',
					icon: '/dist/img/header/features/book.svg',
					name: 'Product Datashseet PDF',
					url: '/pdf/time-tracking-software.pdf',
				},
			],
		};
	},
	components: {
		ATInAction,
		LinkArrow,
	},
};
</script>

<style lang="scss">
@import '../../../../scss/layout/header/header-submenu.scss';
</style>



// WEBPACK FOOTER //
// app/Sites/AT/assets/js/vue/components/header/Features.vue